import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { useAdmin } from '@/context/AdminContext'
import LoadingSpinner from '@/components/common/LoadingSpinner'

interface ProtectedAdminRouteProps {
  children: React.ReactNode
}

export default function ProtectedAdminRoute({ children }: ProtectedAdminRouteProps) {
  const { user, loading: authLoading } = useAuth()
  const { isAdmin, isLoading: adminLoading } = useAdmin()
  const location = useLocation()

  if (authLoading || adminLoading) {
    return <LoadingSpinner fullScreen />
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (!isAdmin) {
    return <Navigate to="/portal" replace />
  }

  return <>{children}</>
}
